import {takeLatestF, putAll, showSuccess, extractFormErrorsFromResponse, NullableKeys} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {genNakedPropOrCrash, opt} from 'ts-opt';
import {call, put, select} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {CreateAssociationBinding} from 'api/gen/CreateAssociationBinding';
import {t} from 'app/translations';
import {formHelpers} from 'utils/forms';
import {showBeError} from 'utils/show-be-error';

import {subjectManagementFormName, SubjectManagementFormValues} from '../../types/subject-management-form-values';
import {adminAction, CreateManagementAssociationAction} from '../action';

const te = t('common');
const title = te('createEntry');

const buildValuesForApi = (formValues: NullableKeys<SubjectManagementFormValues>): CreateAssociationBinding => {
    const get = genNakedPropOrCrash(formValues);

    return {
        approvedFrom: get('approvedFrom'),
        approvedTo: opt(formValues).prop('approvedTo').orNull(),
        roleIds: get('roleIds'),
        associationId: get('subjectId'),
        userProfileId: get('userProfileId'),
    };
};

function* execute({payload: {associationId}}: CreateManagementAssociationAction): SagaIterator {
    const formValues = yield* select(state => formHelpers.formValues(subjectManagementFormName)(state)
        .orCrash(`no form values: ${subjectManagementFormName}`));
    yield* put(formHelpers.startSubmit(subjectManagementFormName));

    const response = yield* call(Api.addUserProfileAssociationRoleBySubjectManager, buildValuesForApi(formValues));

    if (response.isSuccess) {
        yield* put(adminAction.getManagementAssociationsTableData(opt({action: 'refresh'}), opt(associationId)));
        yield* put(showSuccess(title, te('createEntrySuccess'), false, 'createManagementAssociation'));
        yield* put(adminAction.setManagementSubjectModalVisible(null));
        yield* put(formHelpers.reset(subjectManagementFormName));
    } else {
        yield putAll(showBeError(response, title));
        yield* put(formHelpers.stopSubmit(subjectManagementFormName, extractFormErrorsFromResponse(response)));
    }
}

/** Runs the admin saga that creates an association-management binding from the admin form. */
export function* createManagementAssociationSaga(): SagaIterator {
    yield takeLatestF('admin/CREATE_MANAGEMENT_ASSOCIATION', execute);
}
